module.exports = __webpack_public_path__ + "img/im_scrollfeature_05@2x.10da4f96.jpg";